import { MultiDepthTab, TabItem } from "@/shared/lib/navigation/navigation.types"
import { Link, useMatches } from "@tanstack/react-router"

const Sidebar = ({
  title,
  list,
}: {
  title?: string
  list: MultiDepthTab[]
}) => {
  const matches = useMatches()
  const currentPath = matches.at(-1)?.pathname || ""

  return (
    <div className="border-r border-border-color sm:w-64">
      {title ? (
        <header className="mb-4 mt-6 px-4 text-xl">{title}</header>
      ) : null}
      {list.map((menu: MultiDepthTab) => {
        return (
          <div key={menu.href}>
            {menu.name ? (
              <div className="mt-6 flex items-center gap-x-[6px] px-4 py-[11px] text-xs font-medium text-disabled">
                {menu.name}
              </div>
            ) : null}
            {menu.subItems?.map((subItem: TabItem) => {
              const isActive = currentPath.startsWith(subItem.href)

              return (
                <Link
                  to={subItem.href}
                  key={subItem.href}
                  className={`flex items-center gap-x-[6px] px-4 py-[11px] ${isActive ? "bg-outline-button-hovered" : "hover:bg-outline-button-hovered"}`}
                >
                  {subItem.name}
                </Link>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
export default Sidebar
